var React = require('react');

function DifficultyLevelBlack2Outline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#000","fillRule":"nonzero"},[React.createElement("path",{"d":"M6.81-.002l6.233 7.812L6.81 15.62.576 7.81z","key":0}),React.createElement("path",{"d":"M15.81-.002l6.233 7.812-6.233 7.811L9.576 7.81z","key":1})]));
}

DifficultyLevelBlack2Outline.defaultProps = {"viewBox":"0 0 22 16"};

module.exports = DifficultyLevelBlack2Outline;

DifficultyLevelBlack2Outline.default = DifficultyLevelBlack2Outline;
